module.exports = __webpack_public_path__ + "img/iot4shm-min.f5aa1107.png";